import React from "react";
import HomePage from "./views/HomePage";

function App() {
  return <HomePage />;
}

export default App;
